export default __webpack_public_path__ + "static/media/JungleAdventurer.992e40e3.ttf";